import React from 'react'
import { BreakRule } from '../../../../backend/src/services/resources/clocking-rules/clocking-rule.model'
import { User } from '../../api/users'
import { WeekDurationDisplay } from '../missions/mission-week-duration'
import { useWorkPeriodsDuration } from '../../hooks/use-work-period-duration'
import { getWeek, getWeekYear } from '../../utils/date'

interface WorkPeriodsDurationProps {
  workPeriods: {
    start?:
      | {
          date: Date
        }
      | undefined
    end?:
      | {
          date: Date
        }
      | undefined
  }[]
  breakRule?: BreakRule | undefined
  userId?: User['_id']
  period?: string // IsoWeek or IsoMonth
  year?: number
  week?: number
}

export const WorkPeriodsDuration: React.FC<WorkPeriodsDurationProps> = ({
  workPeriods,
  breakRule,
  userId,
  period,
  year,
  week,
}) => {
  const workPeriodsOfWeek = workPeriods.filter(
    wP =>
      wP.start?.date &&
      getWeekYear(new Date(wP.start?.date)) === year &&
      getWeek(new Date(wP.start?.date)) === week,
  )
  const { total, expected } = useWorkPeriodsDuration(workPeriodsOfWeek, breakRule, userId, period)

  return <WeekDurationDisplay total={total ?? 0} expected={expected} />
}
